import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "./redux/store";
import { updateAppointment } from "./redux/slices/appointmentSlice";
import Datalist from "./Datalist";

function AutoCompleteInput({ options, id, setValue, appointment }) {
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();

  const accentColor = appointment?.shopData?.color || "#2b73b9";
  const encodedAccentColor = useMemo(
    () => (accentColor || "#2b73b9").replace("#", "%23"),
    [accentColor]
  );

  // Sync internal state with appointment data (for clearing when make changes)
  useEffect(() => {
    if (id === "Make" && appointment?.vehicle?.make !== undefined) {
      setInputValue(appointment.vehicle.make);
    } else if (id === "Model" && appointment?.vehicle?.model !== undefined) {
      setInputValue(appointment.vehicle.model);
    } else if (id === "Year" && appointment?.vehicle?.year !== undefined) {
      setInputValue(appointment.vehicle.year);
    }
  }, [appointment?.vehicle?.make, appointment?.vehicle?.model, appointment?.vehicle?.year, id]);

  const handleInputChange = (event) => {
    const { value } = event.target;
    
    if (id === "Year") {
      // Validate first, then update state only if valid
      if (value.length <= 4 && /^[0-9]*$/.test(value)) {
        setInputValue(value);
        setValue(value);
        dispatch(
          updateAppointment({
            updates: { vehicle: { ...appointment.vehicle, year: value } },
          })
        );
      } else {
        // Rejected keystroke: put the accepted value back. React restored
        // controlled inputs itself; Preact only does on a re-render.
        event.target.value = inputValue;
      }
    } else if (id === "Make") {
      setInputValue(value);
      setValue(value);
      dispatch(
        updateAppointment({
          updates: { vehicle: { ...appointment.vehicle, make: value } },
        })
      );
    } else if (id === "Model") {
      setInputValue(value);
      setValue(value);
      dispatch(
        updateAppointment({
          updates: { vehicle: { ...appointment.vehicle, model: value } },
        })
      );
    }
  };

  return (
    <div>
      {(id === "Make" || id === "Model") ? (
        // Use proper select dropdown for Make and Model
        <select
          className="w-full box-border p-2 border-2 rounded-lg text-sm appearance-none bg-no-repeat"
          value={inputValue}
          onChange={handleInputChange}
          style={{
            backgroundColor: "#ffffff",
            border: `2px solid ${accentColor}66`,
            color: "#111827",
            outlineColor: accentColor,
            cursor: "pointer",
            fontSize: "16px",
            minHeight: "44px",
            padding: "10px 12px",
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M5 7l5 6 5-6' stroke='${encodedAccentColor}' stroke-width='2.75' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
            backgroundPosition: "right 14px center",
            backgroundSize: "16px 16px",
          }}
        >
          <option value="">{`Select ${id}`}</option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      ) : (
        // Keep input with datalist for Year
        <>
          <input
            type={id === "Year" ? "number" : "text"}
            className="w-full box-border p-2 border-2 rounded-lg text-sm"
            value={inputValue}
            list={id}
            placeholder={id}
            onChange={handleInputChange}
            {...(id === "Year"
              ? { min: appointment?.shopData?.oldestYearServicable }
              : {})}
            style={{
              backgroundColor: "#ffffff",
              border: `2px solid ${accentColor}66`,
              color: "#111827",
              outlineColor: accentColor,
              fontSize: "16px",
              minHeight: "44px",
              padding: "10px 12px",
            }}
          />
          <Datalist data={options} id={id} />
        </>
      )}
    </div>
  );
}

export default AutoCompleteInput;
